import React, { useContext } from 'react'

import { ProductTileV2 } from '@Components/ProductList/ProductTiles/LoadMore/ProductTileV2/ProductTileV2'
import { ProductTileWrapper } from '@Components/ProductList/ProductTileWrapper'
import { AlgoliaProductV2 } from '@Globals/Algolia/Types'
import { algoliaProductToProductTile } from '@Globals/CMS/ProductHelpers'
import { MetadataContext } from '@Globals/Metadata'

import styles from './SearchResults.module.scss'

export const SearchResultsGridV2 = ({
  hits,
}: {
  hits: AlgoliaProductV2[]
}) => {
  const { storeURL } = useContext(MetadataContext)

  return (
    <ProductTileWrapper className={styles.grid2} maxColumns={4}>
      {hits.map((hit) => {
        const tile = algoliaProductToProductTile(hit)
        return (
          <ProductTileV2
            key={tile.id}
            bottomChips={tile.bottomChips}
            brand={tile.brandTitle}
            bundleCombinedValue={tile.bundleCombinedValue}
            hoverImage={tile.hoverImage || undefined}
            isOutOfStock={tile.isOutOfStock}
            originalPrice={tile.beforePrice || tile.price}
            overwrittenPrice={tile.beforePrice ? tile.price : undefined}
            primaryImage={tile.primaryImage}
            productID={tile.id}
            sourceID="inherit"
            title={tile.title}
            topChips={tile.topChips}
            url={storeURL(tile.url)}
            variants={undefined}
            variantsTitle="variantsTitle"
          />
        )
      })}
    </ProductTileWrapper>
  )
}

